import common from '@/store/common/mutations';
import * as types from './mutation-types';
import moment from 'moment';

let searchDate = moment().startOf('year').format('YYYY');

//화면 진입시 초기화
const getInit = () => {
	return {
		searchParams: {
			rsScn: 'RS1', //지수구분
			carScn: '', //차량구분
			pacScn: '', //승상구분
			// customPrCor: 'HTWO', //생산법인
			// plntCd: 'HCJ1', //생산공장
			flclSpc: '', //연료전지사양
			// saleNat: '', //판매국가
			occuRegn: '', //판매지역
			carTypeNm: '', //차종유형
			clmType: '', // 클레입타입
			searchDate: searchDate //기준년도
		},
		rsScnList: [], // 검색 지수구분 셀렉트박스
		carScnList: [], //검색 차량구분 셀렉트박스
		pacScnList: [], //검색 승상구분 셀렉트박스
		// plntCdList: [], //검색 생산공장 셀렉트박스
		flclSpcList: [], //검색 연료전지사양 셀렉트박스
		// saleNatList: [], //검색 판매국가 셀렉트박스
		occuRegnList: [], //검색 판매지역 셀렉트박스
		carTypeNmList: [], //검색 차종유형 셀렉트박스
		// customPrCorList: [], //검색 생산법인 커스텀 셀렉트박스
		clmTypeList: [], //클레임타입 셀렉트 박스

		grdSalesList: [], //그리드리스트
		dayCols: [], //그리드 컬럼(년월컬럼)

		graphBarStackChartInfo: [], //그래프 스택 임시저장소
		graphLineChartInfo: [], //라인차트 임시저장소

		lcMaxVal: '', //라인차트 Y축 최대값 추가
		bcMaxVal: '', //바차트 Y축 최대값 추가
		isLoading: false //추가
	};
};

export default {
	...common,
	[types.STATE_INIT]: state => {
		//초기화
		Object.assign(state, getInit());
	},
	[types.SEARCH_PARAM]: (state, { key, value }) => {
		state.searchParams[key] = value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	}
};
